import styled from 'styled-components';

export const OptionActions = styled.div<{activeStep?: number}>`
display: flex;
align-content: center;
justify-content: ${props=> props.activeStep > 0 ? 'space-between' : 'end'};
`
export const OptionContent = styled.div`
min-height: 200px;
`